import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
export const options = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
      text: 'Chart.js Bar Chart',
    },
  },
  scales: {
    x: {
      grid: {
        color: 'rgba(0,0,0,0.1)',

      },
      border: {
        dash: [2, 6],
      },
    },
    y: {
      grid: {
        display: false,
      },

    },
  },
};

export const ChartsMain = ({ upcomingEventsChartData }) => {
  const [GraphData, setGraphData] = useState([]);
  const [labels, setLabels] = useState([]);
  useEffect(() => {
    let tempData = [];
    let tempDate = [];
    upcomingEventsChartData?.filter((item) => {
      tempData.push(item?.count);
      tempDate.push(item?.date);
    });

    setGraphData(tempData);
    setLabels(tempDate);
  }, [upcomingEventsChartData]);

  const data = {
    labels,
    datasets: [
      {
        label: 'Dataset 1',
        data: GraphData,
        backgroundColor: 'rgba(53, 162, 235, 1)',
      },
    ],
  };
  return (
    <>
      <div className="d-flex justify-content-center w-100 pieChart">
        <Bar
          options={options}
          data={data}
          style={{ width: 500, height: 500 }}
        />
      </div>
    </>
  );
};
